import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectDataForCart } from 'surface_mount_carriers/store/selectors';
import { buildFormData } from 'surface_mount_carriers/store/builder';
import { orderProduct } from 'shared/api/apiOrder';
import { doReQuote } from 'surface_mount_carriers/api/quote';

export const doQuote = createAsyncThunk(
  'smc/doQuote',
  async (_args, thunkAPI) => {
    const currentState = thunkAPI.getState();
    const { parameters, variantId } = currentState.smc;
    const authToken = document.getElementsByName('authenticity_token')[0].value;

    return doReQuote(
      parameters,
      authToken,
      variantId,
      parameters.product_quote_number,
    );
  },
  {
    condition: ({ name }) => {
      if (
        ![
          'carrier_thickness',
          'need_pressure_holder',
          'pressure_holder_quantity',
          'pressure_holder_type',
        ].includes(name)
      ) {
        return false;
      }
      return true;
    },
  },
);

export const addToCart = createAsyncThunk(
  'smc/addToCart',
  async (_args, thunkAPI) => {
    const currentState = thunkAPI.getState();
    const { parameters, variantId, quantity } = selectDataForCart(currentState);
    const form = buildFormData({ parameters, variantId, quantity });

    // eslint-disable-next-line no-undef
    const inputFile = $('#filename');
    const file = inputFile ? inputFile.prop('files')[0] : null;

    if (file) {
      form.append('parameters[filename]', file);
    }

    return orderProduct(form);
  },
);